import { render, staticRenderFns } from "./EmailPushTemp.vue?vue&type=template&id=c631478c&scoped=true"
import script from "./EmailPushTemp.vue?vue&type=script&lang=js"
export * from "./EmailPushTemp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c631478c",
  null
  
)

export default component.exports